export function mergeVars<T>(partial: T, full: T): T {
  const merged = {...full};

  for (const key in partial) {
    if (typeof partial[key] === "object" && typeof full[key] === "object") {
      merged[key] = mergeVars(partial[key], full[key]);
    } else {
      merged[key] = partial[key];
    }
  }

  return merged;
}